export enum MessageType {
  ERROR = 'error',
  ALERT = 'warning', // todo delete (transition to ngx-toastr)
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
  SHOW = 'show'
}
